/**
 * @file 各画面共通の加盟員検索モーダルの検索ボタン
 */
'use strict'

import TableSetStickyColumns from "../Basic/TableSetStickyColumns"

/**
 * @classname BtnCommonMemberSearch
 * @classdesc 各画面共通の加盟員検索モーダルの検索ボタン
 */
export default class BtnCommonMemberSearch {
	/**
	 * @constructor
	 * @param {jQuery} $e - $('.btn-common-member-search')
	 * @param {instance} controller
	 */
	constructor($e, controller) {
		console.log('BtnCommonMemberSearch.constructor')
		this._$e = $e
		this._controller = controller
		this._endpoint = this._$e.data('endpoint')
		this._searchMemberType = this._$e.data('search-member-type')
		console.log(`search-member-type: ${this._searchMemberType}`);
		this._$formControls = this._$e.closest('.modal-body').find('.form-control')
		this._$info = this._$e.closest('.modal-body').find('.result-information')
		this._$table = this._$e.closest('.modal-body').find('.table')
		this._$responseNamesWrap = this._$e.closest('.modal-body').find('.response-names-wrap')
		this._modalElement = document.getElementById('modal-common-member-search')
		this._Modal = bootstrap.Modal.getInstance(this._modalElement)
		this._$e.on('click', () => this.onClick())
		this._controller.on('commonSearchMemberComplete', () => this.onCommonSearchMemberComplete())
	}


	/**
	 * Template: thead
	 *
	 * @memberof BtnCommonMemberSearch
	 * @return {undefined}
	 */
	getTheadTemplate() {
		let $thead = $(`<thead class="thead"></thead>`)
		this._$responseNamesWrap.find('[data-th-name]').each((_, element) => {
			$thead.append(`<th class="th">${$(element).data('th-name')}</th>`)
		})
		$thead.append(`<th class="th">選択</th>`)
		return $thead
	}


	/**
	 * Template: tbody
	 *
	 * @memberof BtnCommonMemberSearch
	 * @return {undefined}
	 */
	getTbodyTemplate() {
		return `<tbody class="tbody"></tbody>`
	}


	/**
	 * Template: エラーメッセージ
	 *
	 * @memberof BtnCommonMemberSearch
	 * @return {undefined}
	 */
	getResultInformationTemplate(type) {
		switch (type) {
			case 'none':
				return this._searchMemberType === 'operator' ? `<div class="fade show alert alert-warning alert-dismissible">操作担当者に指定できる加盟員が存在しません。操作担当者はメールアドレスが登録されている必要があります。<button class="close" type="button" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">×</span></button></div>` : `<div class="fade show alert alert-warning alert-dismissible">該当する情報はありません。<button class="close" type="button" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">×</span></button></div>`
			case 'over':
				return `<div class="fade show alert alert-warning alert-dismissible">検索結果が20件を超えたため、20件目までを表示しています。<button class="close" type="button" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">×</span></button></div>`
		}
	}


	/**
	 * クリックのコールバック
	 *
	 * @memberof BtnCommonMemberSearch
	 * @return {undefined}
	 */
	onClick() {
		console.log('BtnCommonMemberSearch.onClick')
		this._$info.html('')
		this._$table.html('').append($(this.getTheadTemplate())).append($(this.getTbodyTemplate()))
		this._controller.commonSearchMember(this.getSubmitValues(), this._endpoint)
	}


	/**
	 * 送信する値を取得
	 *
	 * @memberof BtnCommonMemberSearch
	 * @return {undefined}
	 */
	getSubmitValues() {
		console.log('BtnCommonMemberSearch.getSubmitValues')
		let submitValues = {}
		this._$formControls.each((_, element) => submitValues[$(element).data('search-item')] = $(element).val())
		return submitValues
	}


	/**
	 * 検索完了時コールバック
	 *
	 * @memberof BtnCommonMemberSearch
	 * @return {undefined}
	 */
	onCommonSearchMemberComplete() {
		console.log('BtnCommonMemberSearch.onCommonSearchMemberComplete')
		console.log(this._controller._memberCount)
		if (this._controller._memberCount == 0) {
			this._$info.append(this.getResultInformationTemplate('none'))
		} else {
			console.log(this._controller._members)
			if (20 < this._controller._memberCount) this._$info.append(this.getResultInformationTemplate('over'))
			this._controller._members.forEach((member, index) => this._$table.find('tbody').append(this.generateTableRow(member, index)))
			new TableSetStickyColumns(this._$table)
		}
	}


	/**
	 * 反映する値を取得
	 *
	 * @memberof BtnCommonMemberSearch
	 * @return {string}
	 */
	getSettingValue(data, index) {
		console.log('BtnCommonMemberSearch.getSettingValue')
		const name = this._$responseNamesWrap.find(`[data-index='${index}']`).data('response-name')
		return name.match(/\:/) ? `${data[name.split(':')[0]]} ${data[name.split(':')[1]]}` : data[name]
	}


	/**
	 * テーブルの行を生成
	 *
	 * @memberof BtnCommonMemberSearch
	 * @return {$tr} - HTML
	 */
	generateTableRow(member, index) {
		console.log('BtnCommonMemberSearch.generateTableRow')
		let $tr = $(`<tr class="tr"></tr>`)
		$tr.append(`<td class="td"><a href="${window.const.STATIC_URL.MEMBER_EDIT}/${this.getSettingValue(member, 1)}" target="_blank" style="text-decoration: underline;">${this.getSettingValue(member, 1)}</a></td>`)
		for (let i = 2; i <= Number(this._$responseNamesWrap.find('[data-th-name]').last().data('index')); i++) {
			$tr.append(`<td class="td">${this.getSettingValue(member, i)}</td>`)
		}
		// 選択ボタンを追加するスコープ
		{
			const $button = $(document.createElement('button'))
			$button.attr({ type: 'button', 'data-index': index, 'data-user-id': this.getSettingValue(member, 0) }).addClass('btn btn-success btn-sm').text('選択')
			$button.on('click', () => this.dispatchCustomEvent(member))
			const $td = $(document.createElement('td'))
			$td.addClass('td tac').append($button)
			$tr.append($td)
		}
		return $tr
	}


	/**
	 * カスタムイベント発火
	 *
	 * @memberof BtnCommonMemberSearch
	 * @return {string}
	 */
	dispatchCustomEvent(data) {
		console.log('BtnCommonMemberSearch.dispatchCustomEvent / event: saj.selected')
		this._modalElement.dispatchEvent(new CustomEvent('saj.selected', { detail: { data: data } }))
		this._Modal.hide()
	}
}
